module.exports = __webpack_public_path__ + "static/media/质量管理体系认证.169aaad9.png";